export default __webpack_public_path__ + "static/media/A03.803c6996.png";